import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';
import avatarSrc from '@chama/statics/assets/svg/icon-employee-neutral.svg';
import NavLink from './NavLink';
import UserDisplay from './UserDisplay';
import './index.css';

const propTypes = {
  links: PropTypes.array.isRequired,
  isSideBarExpanded: PropTypes.bool.isRequired,
  avatarSrc: PropTypes.string,
  username: PropTypes.string.isRequired,
  welcomeMessage: PropTypes.string.isRequired,
  isSoundMuted: PropTypes.bool.isRequired,
  onSoundClick: PropTypes.func.isRequired,
  logoutTooltipText: PropTypes.string.isRequired,
  sirenTooltipText: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
  isDark: PropTypes.bool,
  logout: PropTypes.func.isRequired,
};

const defaultProps = {
  avatarSrc,
  isDark: false,
};

const SideBar = props => {
  const {
    links,
    isSideBarExpanded,
    avatarSrc,
    username,
    logout,
    welcomeMessage,
    isDark,
    logo,
  } = props;
  const { onSoundClick, logoutTooltipText, sirenTooltipText, isSoundMuted } = props;
  const linksIntoNavLinks = link => {
    const { key } = link;
    const navLinkWrapperClass = classNames('SideBar__nav_link_wrapper', {
      'SideBar__nav_link_wrapper--with_border': isSideBarExpanded,
    });

    return (
      <li className={navLinkWrapperClass} key={key}>
        <NavLink {...link} collapseSubMenus={!isSideBarExpanded} />
      </li>
    );
  };
  const sidebarClass = classNames('SideBar', { 'SideBar--dark': isDark });

  return (
    <nav className={sidebarClass}>
      <div className="SideBar__content">
        <div className="SideBar__logo_wrapper">
          <Link className="u__normalize_anchor" to="/">
            <img src={logo} className="SideBar__logo" alt="chama header logo" />
          </Link>
        </div>
        <div className="SideBar__list_wrapper">
          <div className="SideBar__user_display_wrapper">
            <UserDisplay
              avatarSrc={avatarSrc}
              username={username}
              logout={logout}
              isSoundMuted={isSoundMuted}
              onSoundClick={onSoundClick}
              isCollapsed={!isSideBarExpanded}
              welcomeMessage={welcomeMessage}
              logoutTooltipText={logoutTooltipText}
              sirenTooltipText={sirenTooltipText}
            />
          </div>
          <ul className="SideBar__list">{links.map(linksIntoNavLinks)}</ul>
        </div>
      </div>
    </nav>
  );
};

SideBar.propTypes = propTypes;
SideBar.defaultProps = defaultProps;

export default SideBar;



// WEBPACK FOOTER //
// ../ui-components/components/SideBar/index.jsx